function updateHeaderHeight() {
  const header = document.querySelector('.header');
  if (!header) return;
  document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
}

document.querySelector('.js-close')?.addEventListener('click', () => {
  const mess = document.querySelector('.header__mess');
  if (mess) mess.style.display = 'none';
  updateHeaderHeight();
});

updateHeaderHeight();
window.addEventListener('resize', updateHeaderHeight);
